import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const EnrollmentsCategoriesRedux = createActions({},
  {
    prefix: 'ENROLLMENTS_CATEGORIES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = EnrollmentsCategoriesRedux
export const EnrollmentsCategoriesTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/EnrollmentsCategoriesRedux.js